import React from "react";
import { Link } from "react-router-dom";

export const Section = ({ id, title, kicker, children }) => (
  <section id={id} className="mt-14 scroll-mt-24">
    {kicker && <div className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">{kicker}</div>}
    <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h2>
    <div className="mt-5 text-foreground/85 leading-relaxed space-y-4 max-w-3xl">{children}</div>
  </section>
);

export const Hero = ({ kicker, title, subtitle, primary, secondary }) => (
  <section className="pt-10 sm:pt-14">
    {kicker && (
      <span className="inline-flex items-center gap-2 rounded-full border border-emerald-600/30 bg-emerald-600/10 text-emerald-700 dark:text-emerald-300 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-widest">
        {kicker}
      </span>
    )}
    <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight max-w-4xl">
      {title}
    </h1>
    {subtitle && <p className="mt-5 text-base sm:text-lg text-muted-foreground max-w-2xl">{subtitle}</p>}
    {(primary || secondary) && (
      <div className="mt-7 flex flex-wrap gap-3">
        {primary && <Link to={primary.to} className="btn-pill bg-primary text-primary-foreground" data-testid={`hero-primary-${primary.testId || ""}`}>{primary.label}</Link>}
        {secondary && <Link to={secondary.to} className="btn-pill border border-border bg-card">{secondary.label}</Link>}
      </div>
    )}
  </section>
);

export const InternalLinks = ({ title = "Related pages", links }) => (
  <div className="mt-14 card-premium p-6 sm:p-8">
    <h3 className="text-xl font-bold">{title}</h3>
    <div className="mt-4 grid sm:grid-cols-2 gap-3">
      {links.map((l) => (
        <Link key={l.to} to={l.to} className="flex items-center justify-between gap-2 rounded-2xl border border-border px-4 py-3 hover:border-primary hover:bg-primary/5 transition-all group">
          <span className="text-sm font-semibold">{l.label}</span>
          <span className="text-primary opacity-0 group-hover:opacity-100 transition-opacity">→</span>
        </Link>
      ))}
    </div>
  </div>
);
